export default __webpack_public_path__ + "static/media/spiceFarm.39c665ba.webp";